var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500977,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500977,
    y: 0.5,
    width: 31,
    height: 31,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0015 16.049C24.0015 11.6033 20.4197 7.99951 16.002 7.99951C11.5823 8.00051 8.00049 11.6033 8.00049 16.05C8.00049 20.0668 10.9263 23.3965 14.7501 24.0005V18.3759H12.7202V16.05H14.7521V14.2751C14.7521 12.2582 15.947 11.1443 17.7739 11.1443C18.6498 11.1443 19.5648 11.3013 19.5648 11.3013V13.2812H18.5558C17.5629 13.2812 17.2529 13.9021 17.2529 14.5391V16.049H19.4708L19.1168 18.3749H17.2519V23.9995C21.0757 23.3955 24.0015 20.0658 24.0015 16.049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookHover);
export default __webpack_public_path__ + "static/media/facebook_hover.c7929b912fcdf7b3e6d849a97a65cf32.svg";
export { ForwardRef as ReactComponent };